import Gallery from '@/pages/home/components/Gallery';

export default function Galeria() {
  return (
    <main className="min-h-screen bg-background-50">
      <Gallery />
    </main>
  );
}